import { render, staticRenderFns } from "./ActivityLogsTable.vue?vue&type=template&id=be88f97a&"
import script from "./ActivityLogsTable.vue?vue&type=script&lang=js&"
export * from "./ActivityLogsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports